import { flavorStore } from 'client/utils/flavor';
import { FLAVOR_GROUP_NAMES } from 'client/site-modules/shared/constants/flavors';

/**
 * ROI targeting utilities based on flavor tokens.
 * Used for lead form strategy selection when targeting specific dealer groups.
 */

/**
 * Returns true if the flavor indicates ROI targeting — either a canopy group ('canopy*') or a target group ('tg_*').
 * When true, lead forms should use ROI-optimized strategies.
 *
 * @returns {boolean}
 */
export function isRoiTargetedFlavor() {
  return flavorStore.hasGroup(FLAVOR_GROUP_NAMES.CANOPY) || flavorStore.hasGroup(FLAVOR_GROUP_NAMES.TARGET_GROUP);
}
